export const GET_CAREER_SUB_CATEGORIES = "GET_CAREER_SUB_CATEGORIES";
export const GET_CAREER_SUB_CATEGORY_BY_ID = "GET_CAREER_SUB_CATEGORY_BY_ID";
export const UPDATE_CAREER_SUB_CATEGORY = "UPDATE_CAREER_SUB_CATEGORY";
export const DELETE_CAREER_SUB_CATEGORY = "DELETE_CAREER_SUB_CATEGORY";
export const CREATE_CAREER_SUB_CATEGORY = "CREATE_CAREER_SUB_CATEGORY";
